import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

const styles = {
  nav: {
    position: 'sticky', top: 0, zIndex: 100,
    background: '#ffffff',
    borderBottom: '1px solid rgba(0,0,0,0.08)',
    padding: '0 2rem',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    height: '64px',
  },
  logo: {
    fontFamily: "'Inter', ui-sans-serif, system-ui, sans-serif",
    fontWeight: 800, fontSize: '1.5rem',
    color: '#111111',
    letterSpacing: '-0.03em',
    textDecoration: 'none',
  },
  links: { display: 'flex', gap: '0.5rem', alignItems: 'center' },
  link: {
    padding: '0.5rem 1rem', borderRadius: '8px',
    color: '#666680', fontSize: '0.9rem', fontWeight: 500,
    transition: 'all 0.2s', textDecoration: 'none',
  },
  btn: {
    padding: '0.5rem 1.25rem', borderRadius: '8px',
    background: 'linear-gradient(135deg, #3a7d00, #1f4500)',
    color: '#fff', fontSize: '0.9rem', fontWeight: 600,
    border: 'none', cursor: 'pointer',
  },
  ghost: {
    padding: '0.5rem 1.25rem', borderRadius: '8px',
    background: 'transparent', border: '1px solid rgba(0,0,0,0.12)',
    color: '#666680', fontSize: '0.9rem', fontWeight: 500,
    cursor: 'pointer',
  }
};

export default function Navbar({ user }) {
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/');
  };

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.logo}>MacRO</Link>
      <div style={styles.links}>
        <Link to="/" style={styles.link}>Restaurants</Link>
        <Link to="/eatin" style={styles.link}>Eat In</Link>
        {user ? (
          <button onClick={handleSignOut} style={styles.ghost}>Sign Out</button>
        ) : (
          <button onClick={() => navigate('/auth')} style={styles.btn}>Login</button>
        )}
      </div>
    </nav>
  );
}